<template>
    <div class="vm-search-bar flex-box flex-align-items-center">
        <div class="search-bar flex-box flex-item-1 flex-align-items-center lh1">
            <i class="ml4 afd afd-search mr8 fs14 black-3"></i>
            <input ref="input" class="black-8 flex-item-1 fs16" enterkeyhint="search" type="search" v-model="q_pre" @focus="focus" @blur="blur" @keyup.enter="submit" :placeholder="placeholder">
            <span v-if="is_show_submit" class="purple fs14 ml8 gl-hover-text-purple nowrap" @click="submit">{{$t('c.SearchBar.text1')}}</span>
        </div>
        <div class="flex-box fs14">
            <span v-if="is_show_cancel" class="pl16 pr12 black-3 nowrap" @click="cancel">{{$t('c.SearchBar.text2')}}</span>
        </div>
    </div>
</template>

<script>

export default {
    name: 'search-bar',
    props: {
        placeholder:{
          default(){
            return '搜索创作者名字'
          }
        },
        q:{
          default(){
            return ''
          }
        },
        is_show_cancel:{
          default(){
            return false
          }
        },
        is_show_submit:{
          default(){
            return true
          }
        },
        no_enter_submit:{
          default(){
            return false
          }
        },
        is_clear_after_submit:{
          default(){
            return false
          }
        },
        is_close_auto_focus:{
          default(){
            return false
          }
        }
    },
    data() {
        return {
            is_focus:false,
            q_pre:this.q,
        };
    },
    watch:{
        q_pre(newValue){
            this.$emit('change',{
                q:this.q_pre,
            })
        }
    },
    mounted() {
        if(this.$route.name == 'search' || this.$route.name == 'aSlug'){
            setTimeout(() => {
              if(!this.is_close_auto_focus){
                this.$refs.input.focus();
              }
            },20)
        }
    },
    methods: {
        focus(){
            // this.submit()
            this.is_focus = true;
            this.$emit('focus')
        },
        blur(){
            this.is_focus = false;
            this.$emit('blur')
        },
        submit(){
            // setTimeout(() => {
            //     this.$refs.input.blur();
            // },20)
            if(this.no_enter_submit){
              return false;
            }
            this.$emit('search',{
                q:this.q_pre,
            })
            if(this.is_clear_after_submit){
                this.q_pre = ''
            }
        },
        cancel(){
            this.$emit('cancel',{
                q:this.q_pre,
            })
        },
    }
};
</script>

<style lang="stylus" scoped>
.vm-search-bar{
    // padding-right:12px;
    .search-bar{
        padding:8px 16px 8px 10px;
        background: rgba(0, 0, 0, 0.05);
        border-radius: 25px;
        box-sizing:border-box;
        input{
            border: 0;
            outline: 0;
            background: transparent;
            border-radius: 0;
        }
        input[type="search"]{
            -webkit-appearance: none;
        }
        input[type="search"]::-webkit-search-cancel-button {
            display: none;
        }    
    }
}
</style>
